module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"cancelled":"Отмена"},"en":{"cancelled":"cancelled"}}')
  delete Component.options._Ctor
}
